import {
  applyMiddleware,
  combineReducers,
  compose,
  legacy_createStore,
} from "redux";
import thunk from "redux-thunk";
import { commonReducer } from "./reducers/common.reducer";


export const RESET_STORE = "APP/RESET_STORE";

const appReducer = combineReducers({
  common: commonReducer,
});

const rootReducer = (state, action) => {
  if (action?.type === RESET_STORE) {
    state = undefined;
  }
  return appReducer(state, action);
};
const createComposer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = legacy_createStore(
  rootReducer,
  createComposer(applyMiddleware(thunk))
);
